import { render } from "./ModalComponent.vue?vue&type=template&id=27ddeccf&ts=true"
import script from "./ModalComponent.vue?vue&type=script&lang=ts"
export * from "./ModalComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__